import { debounce } from "lodash";
import { startTransition, useCallback, useEffect, useState } from "react";

import eventEmitter from "../../lib/react-redux-modal-provider/eventEmitter";

const useIsHttpRequestsDone = () => {
  const [isHttpRequestsDone, setIsHttpRequestsDone] = useState(false);
  const [isHttpRequestLoading, setIsHttpRequestLoading] = useState(false);

  const debounceSetIsGetResourcesDone = useCallback(
    debounce(() => {
      startTransition(() => {
        setIsHttpRequestsDone(true);
      });
    }, 500),
    []
  );

  useEffect(() => {
    eventEmitter.on("isHttpRequestsLoading", isLoading => {
      setIsHttpRequestLoading(isLoading);
    });

    return () => {
      eventEmitter.removeListener("isHttpRequestsLoading");
    };
  }, []);

  useEffect(() => {
    if (!("PerformanceObserver" in window)) {
      console.warn("PerformanceObserver is not supported in this browser.");
      setIsHttpRequestsDone(true);
      return;
    }

    const observer = new PerformanceObserver(list => {
      const entries = list.getEntries();

      const endedChunkEntries = entries.filter(
        entry =>
          entry.initiatorType === "xmlhttprequest" &&
          entry.entryType === "resource" &&
          entry.responseEnd
      );

      if (endedChunkEntries.length > 0) {
        debounceSetIsGetResourcesDone();
      }
    });

    if (isHttpRequestsDone) {
      observer.disconnect();
      return;
    }

    observer.observe({ entryTypes: ["resource"] });

    return () => {
      debounceSetIsGetResourcesDone.cancel();
      observer.disconnect();
    };
  }, [debounceSetIsGetResourcesDone, isHttpRequestsDone]);

  return {
    isHttpRequestsDone: true
  };
};

export default useIsHttpRequestsDone;
